import React from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "tss-react/mui";
import { isDisplayNameVisible, isNameReadOnly } from "../../../base/config/functions.any";
import { isMobileBrowser } from "../../../base/environment/utils";
import { isScreenShareParticipantById } from "../../../base/participants/functions";
import ConnectionIndicator from "../../../connection-indicator/components/web/ConnectionIndicator";
import DisplayName from "../../../display-name/components/web/DisplayName";
import { STATS_POPOVER_POSITION, THUMBNAIL_TYPE } from "../../constants";
import StatusIndicators from "./StatusIndicators";
const useStyles = makeStyles()(() => {
    return {
        nameContainer: {
            display: "flex",
            overflow: "hidden",
            "&>div": {
                display: "flex",
                overflow: "hidden",
            },
        },
        connectionIndicatorContainer: {
            position: "absolute",
            bottom: "8px",
            right: "8px",
            zIndex: 11,
        },
    };
});
const ThumbnailBottomIndicators = ({ className, local, participantId, showStatusIndicators = true, thumbnailType, }) => {
    const { classes: styles, cx } = useStyles();
    const _allowEditing = !useSelector(isNameReadOnly);
    const _defaultLocalDisplayName = interfaceConfig.DEFAULT_LOCAL_DISPLAY_NAME;
    const _showDisplayName = useSelector(isDisplayNameVisible);
    const isVirtualScreenshareParticipant = useSelector((state) => isScreenShareParticipantById(state, participantId));
    const _isMobile = isMobileBrowser();
    const _isTileView = thumbnailType === THUMBNAIL_TYPE.TILE;
    const _connectionIndicatorDisabled = useSelector((state) => Boolean(state["features/base/config"].connectionIndicators?.disabled));
    const _showConnectionIndicator = _isMobile && _isTileView && !_connectionIndicatorDisabled;
    const iconSize = 16;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: cx(className, "bottom-indicators") },
            showStatusIndicators && (React.createElement(StatusIndicators, { audio: !isVirtualScreenshareParticipant, moderator: true, participantID: participantId, screenshare: isVirtualScreenshareParticipant, thumbnailType: thumbnailType })),
            _showDisplayName && (React.createElement("span", { className: styles.nameContainer },
                React.createElement(DisplayName, { allowEditing: local ? _allowEditing : false, displayNameSuffix: local ? _defaultLocalDisplayName : "", elementID: local ? "localDisplayName" : `participant_${participantId}_name`, participantID: participantId, thumbnailType: thumbnailType })))),
        _showConnectionIndicator && (React.createElement("div", { className: styles.connectionIndicatorContainer },
            React.createElement(ConnectionIndicator, { alwaysVisible: true, enableStatsDisplay: false, iconSize: iconSize, isMobileWeb: true, participantId: participantId, statsPopoverPosition: STATS_POPOVER_POSITION[thumbnailType] })))));
};
export default ThumbnailBottomIndicators;
